module.exports = __webpack_public_path__ + "static/media/Plus.2eebb97e.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/images/Plus.PNG
// module id = 1542
// module chunks = 1